import { useEffect, useState } from "react";
import { Button, CircularProgress, IconButton, InputLabel, NativeSelect, Switch, TextField } from "@mui/material";
import { Image as ImageIcon } from '@mui/icons-material'
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from 'react-query'
import { ValidationSchema } from "../services/schemaValidation";
import { ValidateErrorMessage } from "components/ValidateErrorMessage";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { edit } from "../services/api";
import { useTranslation } from "react-i18next";
import { DataFields } from "../Add/DataFields";
import FormBuilder from "components/Inputs/FormBuilder";
import DialogMenuImageManager from "routes/ImageManager/DialogMenuImageManager";

export default function Edit({ open, close, menu, category, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  let { reset, handleSubmit, register, formState: { errors }, setValue }  = useForm({ 
    resolver: yupResolver(ValidationSchema)
  })

  useEffect(() => {
    if(open) {
      setDataInstance(instance)
      reset(instance)
    }
  }, [open])

  const mutation = useMutation(edit, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleEdit = (params) => { 
    //console.log("prueba", params)
    setIsLoading(true)
    let id = params._id
    delete params._id
    delete params.products
    delete params.deleted
    delete params.createdAt
    delete params.updatedAt
    mutation.mutate({ id, params })
  }
  
  const handleClose = () => { reset(); setDataInstance({}); close() }

  const handleOnChangeData = (event) => { 
    if(event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  const handleChangeBoolean = (name) => {
    setDataInstance({...dataInstance, [name]: !dataInstance[name]}) 
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }
  const handleCloseImageManager = ( prop ) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = ( prop ) => { setDataFieldImageManager(prop) }  
  const handleSelectImageManager = (url) => {
    setDataInstance({...dataInstance, [dataFieldImageManager]: url})
    setValue(dataFieldImageManager, url)
  }

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleEdit)}>{t('button_text_edit')}</Button>
      </> : <CircularProgress /> }
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('builder_subcategories_dialog_title_edit')} actions={<Actions />}>
      <>
        <input type="hidden" name="category" {...register(`category`)} value={category}/>
        <ValidateErrorMessage message={errors.menu?.message} />
        <FormBuilder
          dataDields={DataFields(t)}
          dataInstance={dataInstance}
          containerSelectOptions={{ presentations: [{value: 0, label: "Comida"}, {value: 1, label: "Bebidas"}] }}
          register={register}
          errors={errors}
          changeDataFunction={handleOnChangeData}
          changeDataBoolean={handleChangeBoolean}
          openImageManager={handleOpenImageManager}
          setFieldImageManager={handleFieldImageManager} />
      </>
    </FlexibleWidthDialog>
    <DialogMenuImageManager
      open={ imageManagerModalOpen } 
      menu={ menu }
      actionClose={ handleCloseImageManager } 
      setImageSelected={ handleSelectImageManager } />
  </>)
}